import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class FilterIcon extends BaseOption {
  static userInterfaceComponent = {
    label: "Filter Icon",
    component: inspectorTools.ICON_PICKER,
  };

  static defaultValue = "mdi:filter-outline";
}
